module.exports = "<ngb-alert *ngIf=\"!_staticAlertClosed\" (close)=\"_staticAlertClosed = true\" type=\"{{_type}}\" [@flipX]>{{_message}}</ngb-alert>"